import React from 'react';
//import {authRoles} from '../../auth';

export const UserDepartUpdateConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth: ['master', 'rh', 'rh_not_signer'],
    routes: [{
        path: '/user-depart-details/:id',
        component: React.lazy(() =>
            import ('./UserDepartUpdate'))
    }]
};